import {ReactNode} from 'react';
import {Navigate} from 'react-router-dom';
import {useAppSelector} from '../../hooks/useAppSelector';
import {selectCurrentToken, selectSession} from '../../../features/auth/authSlice';
import {Session} from '../../../features/auth/types';

export interface ProtectedRouteProps {
  children: ReactNode;
  protectionType?:
    | 'payment'
    | 'subscription'
    | 'token'
    | ((data: {session: Session | null; token: string | null}) => boolean);
  redirectTo?: string;
}

export const ProtectedRoute = ({children, protectionType = 'token', redirectTo}: ProtectedRouteProps) => {
  const token = useAppSelector(selectCurrentToken);
  const session = useAppSelector(selectSession);

  if (typeof protectionType === 'function' && !protectionType({session, token})) {
    return <Navigate replace to={redirectTo ?? '/sign-in'} />;
  }

  if (protectionType === 'token' && token == null) {
    return <Navigate replace to={redirectTo ?? '/sign-in'} />;
  }

  if (
    protectionType === 'subscription' &&
    (!session?.subscriptionType || (session?.subscriptionIsValid !== 'true' && session?.subscriptionValidUntil == null))
  ) {
    return <Navigate replace to={redirectTo ?? '/subscription'} />;
  }

  if (
    protectionType === 'payment' &&
    session?.subscriptionIsValid !== 'true' &&
    session?.subscriptionValidUntil != null
  ) {
    return <Navigate replace to={redirectTo ?? '/profile/membership'} />;
  }

  return <>{children}</>;
};
